import { createContext, useContext } from 'react';
import { ProjectData } from '../types';

export interface ProjectContextData {
  data: ProjectData;
  refetch: () => Promise<ProjectData | undefined>;
}

export const ProjectDataContext = createContext<Nullable<ProjectContextData>>(null);

export const useProjectDataContext = () => {
  const context = useContext(ProjectDataContext);
  if (!context) {
    throw new Error('useProjectDataContext must be used within ProjectDataContext.Provider');
  }
  return context;
};
